// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Stickers__container-dc9141 {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(auto-fill, 85px);
  gap: 16px 8px;
  align-items: start;
  padding: 16px;
  overflow: auto;
  user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/StickerPackPopup/Stickers/Stickers.styles.m.scss"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,qCAAA;EACA,2CAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-template-rows: repeat(auto-fill, 85px);\n  gap: 16px 8px;\n  align-items: start;\n  padding: 16px;\n  overflow: auto;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Stickers__container-dc9141`
};
module.exports = ___CSS_LOADER_EXPORT___;
